import { orderBy } from 'lodash-es';
import type { z } from 'zod';
import type {
  ActivityModel,
  IndicatorModel,
  TermType,
} from '../projects/_models/activity';

export const INDICATOR_ID_SEPARATOR = '_';
export const INDICATOR_LABEL_SEPARATOR = '-';

export const getOrderByTerm = (term: TermType | null | undefined) => {
  switch (term) {
    case 'short':
      return 2;
    case 'medium':
      return 3;
    case 'long':
      return 4;
    default:
      return 1;
  }
};

export const sortEdges = <
  T extends Record<
    K,
    | {
        activity?: Pick<z.infer<typeof ActivityModel>, 'sortOrder'> | null;
        indicator?: Pick<
          z.infer<typeof IndicatorModel>,
          'type' | 'term' | 'sortOrder'
        > | null;
      }
    | undefined
  >,
  K extends keyof T,
>(
  edges: Array<T>,
  keyName: K,
) => {
  return orderBy(edges, [
    (edge) => (edge[keyName]?.activity ? 0 : 1),
    (edge) => edge[keyName]?.activity?.sortOrder,
    (edge) => (edge[keyName]?.indicator?.type === 'output' ? 0 : 1),
    (edge) => getOrderByTerm(edge[keyName]?.indicator?.term),
    (edge) => edge[keyName]?.indicator?.sortOrder,
  ]);
};
